import { newestCachedAt } from './db';
import { estaAlcancavel, verificarAlcance, aoMudarAlcance, marcarInalcancavel } from './alcance';

/**
 * Estado de conexão, para a tela poder avisar que está mostrando cópia local.
 *
 * O técnico em campo precisa saber se o que está na tela é de agora ou da
 * última vez que teve sinal — sem isso ele não sabe se pode confiar no número.
 *
 * A resposta vem de `alcance.js`, que pergunta ao servidor, e não de
 * `navigator.onLine` — que afirma estar conectado sempre que existe adaptador
 * com link, mesmo sem rota.
 */

export const isOnline = () => estaAlcancavel();

/**
 * Acompanha a conexão.
 *
 * Reage aos eventos do sistema (rápidos, mas mentirosos para "voltou") e a uma
 * verificação periódica de alcance. `intervaloMs` maior quando não há nada
 * pendente: sem fila para enviar, insistir só gasta bateria e dados.
 */
export const watchConnection = (onChange, { intervaloMs = 30000 } = {}) => {
  const soltarOuvinte = aoMudarAlcance(onChange);

  // Evento do sistema é sinal para VERIFICAR, não resposta pronta. "offline"
  // é confiável; "online" só quer dizer que apareceu um adaptador.
  const aoEventoDoSistema = () => { verificarAlcance(); };
  window.addEventListener('online', aoEventoDoSistema);
  window.addEventListener('offline', aoEventoDoSistema);

  verificarAlcance();
  const timer = setInterval(() => { verificarAlcance(); }, intervaloMs);

  return () => {
    soltarOuvinte();
    clearInterval(timer);
    window.removeEventListener('online', aoEventoDoSistema);
    window.removeEventListener('offline', aoEventoDoSistema);
  };
};

export { verificarAlcance, marcarInalcancavel, newestCachedAt };
